import { createFragmentContainer, graphql } from "react-relay";
import { useState, useCallback } from "react";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

interface StackNotificationEvent {
  uuid: string;
  timestamp: string;
  message: string;
}

type Props = {
  event: StackNotificationEvent;
  previousTimestamp: string | null | undefined;
};

const MAX_TRUNCATED_LENGTH = 500;

function JobEventStackNotification({ event, previousTimestamp }: Props) {
  const notificationDetail = event.message || "";
  const shouldTruncate = notificationDetail.length > MAX_TRUNCATED_LENGTH;
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Stack Notification for Job</JobEvent.Label>
      <JobEvent.Content>
        <div className="bg-silver border-gray m-0 whitespace-pre-wrap rounded border px-2 py-1 text-sm font-normal">
          <span className="whitespace-pre-wrap" id={`notification-detail-${event.uuid}`}>
            {isExpanded ? notificationDetail : notificationDetail.slice(0, MAX_TRUNCATED_LENGTH)}
          </span>
          {shouldTruncate && !isExpanded && <span>...</span>}
          {shouldTruncate && (
            <button
              type="button"
              onClick={toggleExpanded}
              className="no-title-tooltip ml-2 font-medium"
              aria-expanded={isExpanded}
              aria-controls={`notification-detail-${event.uuid}`}
              aria-label={
                isExpanded ? "Show full notification details" : "Show less notification detail"
              }
            >
              {isExpanded ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      </JobEvent.Content>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventStackNotification, {
  event: graphql`
    fragment JobEventStackNotification_event on JobEvent {
      ... on JobEvent {
        uuid
        timestamp
        ... on JobEventStackNotification {
          message
        }
      }
    }
  `,
});
